import React, { useEffect, createElement } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function SEO() {
  const {
    language
  } = useLanguage();
  const meta = {
    en: {
      title: 'IT Monsters — Modern Website for €299 | Free Demo First',
      description: 'Get a free website demo in 1–3 days. Pay only if you approve: €299 one-time. Done-for-you launch, domain connection, and lead form setup. Worldwide service.'
    },
    ru: {
      title: 'IT Monsters — Современный сайт под ключ за €299 | Бесплатное демо',
      description: 'Получите бесплатное демо сайта за 1–3 дня. Оплата только если понравится: €299 единоразово. Запуск под ключ, подключение домена и формы заявок. Работаем по всему миру.'
    },
    ua: {
      title: 'IT Monsters — Сучасний сайт під ключ за €299 | Безкоштовне демо',
      description: 'Отримайте безкоштовне демо сайту за 1–3 дні. Платите лише якщо сподобається: €299 одноразово. Запуск під ключ, підключення домену та форми заявок. Працюємо по всьому світу.'
    },
    pl: {
      title: 'IT Monsters — Nowoczesna strona za €299 | Darmowe demo',
      description: 'Otrzymaj darmowe demo strony w 1–3 dni. Płacisz tylko, jeśli zaakceptujesz: €299 jednorazowo. Uruchomienie pod klucz, podłączenie domeny i formularz kontaktowy. Działamy globalnie.'
    }
  };
  useEffect(() => {
    const currentMeta = meta[language] || meta.en;
    // Update title
    document.title = currentMeta.title;
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', currentMeta.description);
  }, [language]);
  return null;
}